package de.katoonerie.components

import androidx.compose.runtime.Composable
import de.katoonerie.stylesheet.AppStylesheet
import org.jetbrains.compose.web.dom.Div

@Composable
fun Gradient(content: @Composable () -> Unit) {
    Div(attrs = { classes(AppStylesheet.gradient) }) {
        content()
    }
}
